import { Point } from "../../models";

export const communityCardPositions: Point[] = [
  { x: 242, y: 756 },
  { x: 362, y: 756 },
  { x: 482, y: 756 }, // top-left
  { x: 602, y: 756 },
  { x: 722, y: 756 },
];
export const r2tT1Positions: Point[] = [
  { x: 322, y: 715 },
  { x: 417, y: 715 },
  { x: 512, y: 715 }, // top-left
  { x: 607, y: 715 },
  { x: 700, y: 715 },
];
export const r2tT2Positions: Point[] = [
  { x: 322, y: 840 },
  { x: 417, y: 840 },
  { x: 512, y: 840 }, // top-left
  { x: 607, y: 840 },
  { x: 700, y: 840 },
];
export const r2tCardScale: Point = { x: 1, y: 1 };
export const communityCardScale: Point = { x: 1.35, y: 1.35 };
